import { stripHtml } from "utils/formConfigUtils"
import * as Yup from "yup"
export const TOGGLE_STATUS = {
   Yes: "Yes",
   No: "No",
}
export const FIELDS_NAME = {
   NAME: "name",
   PRICE: "price",
   YEAR: "year",
   STATUS: "status",
   DESCRIPTION: "description",
   DEFAULT: "default",
   IS_POPULAR: "popular",
   TRAILER_TYPE: "trailerType",
}
export const initialValues = {
   [FIELDS_NAME.PRICE]: "",
   [FIELDS_NAME.NAME]: "",
   [FIELDS_NAME.YEAR]: "",
   [FIELDS_NAME.STATUS]: "ACTIVE",
   [FIELDS_NAME.DESCRIPTION]: "",
   [FIELDS_NAME.DEFAULT]: false,
   [FIELDS_NAME.IS_POPULAR]: false,
   [FIELDS_NAME.TRAILER_TYPE]: [],
}
export const validationSchema = Yup.object({
   [FIELDS_NAME.NAME]: Yup.string()
      .required("Enter warranty name")
      .min(1, "Name must be at least 1 character")
      .max(100, "Name can't be more than 100 characters"),
   [FIELDS_NAME.STATUS]: Yup.string().required("Select status"),
   // [FIELDS_NAME.TRAILER_TYPE]: Yup.mixed().test(
   //    "trailerType",
   //    "Select at least one trailer type",
   //    value => {
   //       return Array.isArray(value) && value.length > 0
   //    }
   // ),
   [FIELDS_NAME.PRICE]: Yup.string()
      .required("Enter price")
      .when(FIELDS_NAME.DEFAULT, {
         is: true,
         then: schema =>
            schema
               .matches(/^0$/, "Price must be 0 for default warranty")
               .test(
                  "is-zero-strict",
                  "Price must be 0 for default warranty",
                  value => Number(value) === 0
               ),
         otherwise: schema =>
            schema
               .matches(/^\d+(\.\d+)?$/, "Enter valid price")
               .test(
                  "length-check",
                  "Price must be between 1 and 8 digits",
                  value => {
                     if (!value) return false
                     return value.length >= 1 && value.length <= 8
                  }
               )
               .test(
                  "valid-number",
                  "Price must be greater than 0 for non-default warranty",
                  value => {
                     const num = Number(value)
                     return !isNaN(num) && num > 0
                  }
               ),
      }),
   [FIELDS_NAME.YEAR]: Yup.number("Enter numbers only").required(
      "Enter number of years"
   ),
   [FIELDS_NAME.DESCRIPTION]: Yup.string()
      .nullable()
      .required("Description is required")
      .test("description-not-empty", "Description is required", value => {
         if (!value) return false
         const plainText = stripHtml(value).trim()
         return plainText.length > 0
      }),
   [FIELDS_NAME.DEFAULT]: Yup.boolean().required("Select one"),
   [FIELDS_NAME.IS_POPULAR]: Yup.boolean().required("Select one"),
})
